// Disabling rule due to this issue https://stackoverflow.com/questions/69202975/module-not-found-cant-resolve-swiper-react
/* eslint-disable import/no-unresolved */
import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';
import { Box } from '@mui/material';

const SwiperCarousel = props => (
  <Box sx={props.style}>
    {props.isHandsetDetails ? (
      <Swiper {...props.settings}>{props.children}</Swiper>
    ) : (
      <Swiper {...props.settings} ref={props.sliderRef}>
        {props.children}
      </Swiper>
    )}
  </Box>
);

export default SwiperCarousel;
